import Image from 'next/image';
import { useState } from 'react';

const CachedImage = ({ imageUrl, className, alt = 'traviya tour and travel', width = 600, height = 400 }) => {
    const encodedUrl = encodeURIComponent(imageUrl);  // Correct encoding
    const cachedImageUrl = `/api/cache-image?imageUrl=${encodedUrl}`;

    const [hasError, setHasError] = useState(false);
    return (
        <Image
            src={hasError ? imageUrl : cachedImageUrl}
            alt={alt}
            width={width}
            height={height}
            unoptimized
            className={className}
            onError={() => setHasError(true)}
        />
    );
};

export default CachedImage;
